export default {
  TOKEN: 'HEARTBEAT_TOKEN',
  REFRESH_TOKEN: 'HEARTBEAT_REFRESH_TOKEN',
  LOGIN_COUNTER: 'LOGIN_COUNTER',
  USER: 'HEARTBEAT_USER'
};
